// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"212":"f0d98bde","740":"54cc030e"}[chunkId] + ".chunk.css";
};